export const ToastTypes = {
    Error: "error",
    Info: "info",
} as const;

export type ToastType = typeof ToastTypes[keyof typeof ToastTypes];